const multiplier = new Map()

// each quantity of items has its multiplication factor and was provided by the data area
multiplier.set(1, 1.13)
multiplier.set(2, 0.47)
multiplier.set(3, 0.47)
multiplier.set(4, 0.36)
multiplier.set(5, 0.32)
multiplier.set(6, 0.34)
multiplier.set(7, 0.31)
multiplier.set(8, 0.31)
multiplier.set(9, 0.3)
multiplier.set(10, 0.27)
multiplier.set(11, 0.29)
multiplier.set(12, 0.24)
multiplier.set(13, 0.23)
multiplier.set(14, 0.23)
multiplier.set(15, 0.25)
multiplier.set(16, 0.23)
multiplier.set(17, 0.28)
multiplier.set(18, 0.24)
multiplier.set(19, 0.18)
multiplier.set(20, 0.15)

// returns seconds
export function calculatePreparingTime(totalItems: number): number {
  if (!totalItems) return 0
  if (totalItems < 20) {
    return Math.round(totalItems * multiplier.get(totalItems) * 60)
  }
  return Math.round(totalItems * 0.15 * 60)
}
